import React from 'react';
import '../styles/landolt.scss';

interface Props {
	direction: number;
	baseSize: number;
	scaleFactor: number;
	fontColor?: string;
	fontUnit?: 'pt' | 'em'
}

export const Landolt: React.FunctionComponent<Props> = props => {
	// 1.54 - the fudge factor is to account for the difference in the ring size with respect to the font charachter
	// The ring is much smaller than the font character (1.54 factor) - we can put this back if this is required.

	const fudgeFactor = 1;
	const fontSize = props.baseSize * props.scaleFactor;
	const fontColor = props.fontColor || '#000000';
	const fontUnit = props.fontUnit || 'pt';
	return (
		<div
			className={"eye-test__landolt"}
			style={{
				fontSize: fontSize * fudgeFactor + fontUnit,
				color: fontColor
			}}
		>
			<span>{props.direction}</span>
		</div>
	);
};
